import { blue } from '@ant-design/colors'
import React, { FC } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { StyledIcon } from '../../styled-icon/StyledIcon'
import { faScrewdriverWrench } from '@fortawesome/pro-regular-svg-icons/faScrewdriverWrench'

type StyledToolsIconProps = {}

export const StyledToolsIcon: FC<StyledToolsIconProps> = () => {
	return (
		<StyledIcon color={blue[6]} icon={<FontAwesomeIcon icon={faScrewdriverWrench} />} />
	)
}